import React, { Component } from 'react';

import BambooRouter from './Router.js';
import withAuth from 'components/withAuth/withAuth';
import 'App.css';

class App extends Component {
  render() {
    return (
      <BambooRouter></BambooRouter>
    );
  }
}

export default withAuth(App);
